import { ref } from "vue";
import { defineStore } from "pinia";

/**
 * 登录回调状态管理 store
 * 用于管理第三方登录成功后的回调操作
 */
export const useLoginCallbackStore = defineStore(
  "loginCallback",
  () => {
    // 是否是主动登录（true: 主动登录，不触发回调；false: 允许触发回调）
    const isActiveLogin = ref(false);

    /**
     * 设置主动登录标志（阻止触发第三方登录回调）
     */
    function setActiveLogin() {
      isActiveLogin.value = true;
    }

    /**
     * 清除主动登录标志（允许触发第三方登录回调）
     */
    function clearActiveLogin() {
      isActiveLogin.value = false;
    }

    return {
      isActiveLogin,
      setActiveLogin,
      clearActiveLogin,
    };
  },
  {
    persist: {
      storage: import.meta.client ? localStorage : undefined,
    },
  }
);
